<template>
    <ElementLocaleProvider>
        <router-view></router-view>
    </ElementLocaleProvider>
</template>
<script setup lang="ts">
import { onMounted } from 'vue';
import { BiTrackService } from '@eureka/domains/src/bi-track/services/bi-track-service';
import { EurekaTrackEventType } from '@eureka/domains/src/bi-track/types';
import { getVar } from '@eureka/utils/environment';
import { InitCookie } from '@patsnap/init-cookie';
import { injectService } from '@patsnap/tahiti-core/ioc/inject';
// import { controlDeferred } from '@eureka/utils/control';
// import { UsageAmountWhere } from '@eureka/shared/edition-upgrade/src/constants';
// import { EurekaPackageType } from '@eureka/services/src/apis/common.api.types';
import ElementLocaleProvider from '@/components/ElementLocaleProvider.vue';

// async function openEditionUpgradeFirstLogin() {
//     const { is_first_login_after_try_end } = await controlDeferred.promise;
//     if (is_first_login_after_try_end) {
//         import('@eureka/shared/edition-upgrade').then((mod) => {
//             mod.prepareFirstLoginAfterTrial(UsageAmountWhere.TECH_SEEK, EurekaPackageType.AIR_COMMERCIAL);
//         });
//     }
// }

// openEditionUpgradeFirstLogin();

onMounted(async() => {
    // 检查登录状态
    const startFrom = getVar('start_from') || 'ip_home';
    if (startFrom) {
        const biTrackService = injectService<BiTrackService>(BiTrackService);
        biTrackService.biTrack(EurekaTrackEventType.SS_PLG_PAGE_VIEW, {
            sourceType: 'ip_home',
            eventDetailStr: {
                agentSource: startFrom,
                signatureId: InitCookie.getVisitorId() || 'ip_home',
                campaignName: InitCookie.getCampaignName(),
            },
        });
    }
});
</script>
